<template>
  <div class="login-wrapper">
    <div class="content-wrapper">
      <div class="content-form">
        <div class="title">
          <img src="./../../assets/newlogo.png" alt="">
        </div>
        <div>
          <a-form
            :form="form"
            @submit="handleSubmit"
          >
            <a-form-item>
              <a-input
                v-decorator="[
                  'username',
                  {
                    rules: [
                      {
                        required: true,
                        message: '请输入用户名！'
                      }
                    ]
                  }
                ]"
                size="large"
                placeholder="登录编号/用户名/邮箱"
              >
  			  <template #prefix>
  			         <img src="./../../assets/Frame.png"  alt="">
  			    </template>
  			</a-input>
            </a-form-item>
            <a-form-item>
              <a-input
                v-decorator="[
                  'password',
                  {
                    rules: [
                      {
                        required: true,
                        message: '请输入密码！'
                      }
                    ]
                  }
                ]"
                size="large"
                type="password"
                placeholder="请输入密码"
              >
  			  <template #prefix>
  			           <img src="./../../assets/pass.png"  alt="">
  			      </template>
  			  </a-input>
            </a-form-item>
            <!-- <a-form-item>
              <a-input-search
                v-decorator="[
                  'img_code',
                  {
                    rules: [
                      {
                        required: true,
                        message: '请输入验证码！'
                      }
                    ]
                  }
                ]"
                placeholder="验证码"
                size="large"
                @search="onSearch"
              >
                <a-button
                  slot="enterButton"
                  style="padding:0;"
                >
                  <img
                    height="36px"
                    :src="codeUrl"
                  >
                </a-button>
              </a-input-search>
            </a-form-item>-->
            <a-form-item class="login-btn">
              <a-button
                :loading="btnIsLoading"
                type="primary"
                html-type="submit"
                style="width:100%;border-radius:30px;background: #2A67DA;height: 60px;font-size: 18px;"
                size="large"
              >
                立即登录
              </a-button>
            </a-form-item>
          </a-form>
        </div>
      </div>
    </div>
    <!-- <div class="footer">
      <span class="footerText">COPYRIGHT <span>2020重庆易药云科技有限公司</span> 渝IPC备20006570号</span>
    </div> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      btnIsLoading: false,
      authCode: '',
      form: this.$form.createForm(this),
      // codeUrl: '',
    };
  },
  mounted() {
    // this.onSearch();
  },
  methods: {
    // // 获取验证码
    // onSearch() {
    //   let random = new Date().getTime();
    //   this.codeUrl = `${this.uploadUrl}system/codeImg?${random}`;
    // },
    // 登录
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields(async(err, values) => {
        if (!err) {
          this.btnIsLoading = true;
          let result = await this.$http.post('/user/login', values);
          this.btnIsLoading = false;
          if (result.data.status === 1) {
            localStorage.setItem('uid', result.data.data.uid);
            localStorage.setItem('is_admin', result.data.data.is_admin);
            localStorage.setItem('token', result.data.data.token);
            localStorage.setItem('userName', result.data.data.username);
            this.$router.push('/');
          }
          // else {
          //   this.onSearch();
          // }
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.login-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
background: #E9EDFA;
  .content-wrapper {
    width: 1000px;
    height: 537px;
    background: url("./../../assets/bj.png") no-repeat;
    position: relative;
    .content-form {
      width: 430px;
      height: 350px;
      // background: rgba(255, 255, 255, 1);
      // box-shadow: 0px 11px 24px 0px rgba(52, 52, 137, 0.22);
      // border-radius: 20px;
      position: absolute;
      left: 40px;
      top: 114px;
      padding: 20px;
      .login-btn {
        margin-top: 40px;
      }
      .title {
        padding-bottom: 24px;
		img{
			width: 193.54px;
			height: 34px;
		}
      }
      .ant-input-affix-wrapper {
        border-radius: 12px;
		height: 52px;
      }
    }
  }
  .footer {
    display: block;
    position: absolute;
    bottom: 25px;
    font-size: 12px;
    font-weight: 100;
    color: rgba(255, 255, 255, 1);
    opacity: 0.5;
    .footerText {
      &::before {
        content: "";
        width: 200px;
        height: 1px;
        position: absolute;
        left: -220px;
        top: 8px;
        background-image: linear-gradient(
          to right,
          rgba(255, 255, 255, 0.05),
          rgba(255, 255, 255, 0.5)
        );
      }
      &::after {
        content: "";
        width: 200px;
        height: 1px;
        position: absolute;
        right: -220px;
        top: 8px;
        background-image: linear-gradient(
          to right,
          rgba(255, 255, 255, 0.5),
          rgba(255, 255, 255, 0.05)
        );
      }
      span{
        margin:0 5px;
      }
    }
  }
}
</style>
